import { Component, Input, OnChanges } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { DvsUtilities } from "src/app/dvs-utilities";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-files-control",
	templateUrl: "./files-control.component.html",
	styleUrls: ["./files-control.component.scss"]
})
export class FilesControlComponent implements OnChanges {
	@Input()
	asset: APIResults.Asset;

	public listing: APIResults.FileListing;
	public isUploading = false;
	public uploadError = undefined;
	public uploadSuccess = undefined;

	constructor(private api: ApiService) { }

	async ngOnChanges(): Promise<void> {
		await this.RefreshPath();
	}

	private async RefreshPath() {
		this.listing = undefined;
		this.listing = await this.api.GetFileListing(this.asset.asset_id, "control", "");
	}

	public async DownloadFile(file: string) {
		await this.api.GetFileDownload(this.asset.asset_id, "control", file, file);
	}

	public async DeleteFile(file: string) {
		await this.api.DeleteControlFile(this.asset.asset_id, file);
		await this.RefreshPath();
	}

	public async PerformUpload(event: any) {
		this.isUploading = true;
		this.uploadError = undefined;
		this.uploadSuccess = undefined;
		try {
			const files: File[] = Array.from(event.target.files);
			for (const file of files) {
				await this.api.UploadControlFile(this.asset.asset_id, file);
			}
			await this.RefreshPath();
			const uploaded = (files.length !== 1) ? files.length + " files" : files[0].name
			this.uploadSuccess = uploaded + " uploaded successfully";
		} catch (err) {
			this.uploadError = "Error: " + DvsUtilities.GetRemoteErrorMessage(err, true);
		} finally {
			this.isUploading = false;
		}
	}
}
